import { z } from 'zod'

const jsonResponse = z.object({}).passthrough()

export const legacySyncHealthResponseSchema = jsonResponse
export const legacySyncHydrateResponseSchema = jsonResponse
export type LegacySyncHealthResponse = z.infer<typeof legacySyncHealthResponseSchema>
export type LegacySyncHydrateResponse = z.infer<typeof legacySyncHydrateResponseSchema>
